import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { IdentityService } from './user/services/identity.service';
import * as firebase from 'firebase/app';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html'
})
export class AppComponent implements OnInit{
  constructor(private identityService: IdentityService, private router: Router){}
  identity: any;
  ready = false;
  q: string;

  async ngOnInit(){
    this.identity = await this.identityService.getIdentity();
    this.ready = true;
  }
  async search(){
    if (this.q){
      this.router.navigate(['/m/l'],{queryParams:{q:this.q}});
    }
  }
  async signout(){
      await firebase.auth().signOut();
      await this.router.navigate(['/m/signin']);
  }
}
